import { signOut } from "firebase/auth";
import React from "react";
import { Container, Nav, Navbar } from "react-bootstrap";
import { useAuthState } from "react-firebase-hooks/auth";
import { Link } from "react-router-dom";
import auth from "../../../firebase.init";

const Header = () => {
  const [user, loading, error] = useAuthState(auth);

  const handleSignOut = () => {
    signOut(auth);
  };

  return (
    <div>
      <Navbar fixed="top" bg="light" expand="lg">
        <Container>
          <Navbar.Brand
            className="text-black fs-3 fw-bold  "
            as={Link}
            to={"/home"}
          >
            TECH GIANT
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav>
              <Nav.Link className=" fw-bold" as={Link} to={"/home"}>
                Home
              </Nav.Link>
            </Nav>
            <Nav className="ms-auto text-black fw-bold">
              {user ? (
                <button
                  onClick={handleSignOut}
                  className={
                    "d-inline btn btn-link text-decoration-none me-auto "
                  }
                >
                  Logout
                </button>
              ) : (
                <Nav.Link as={Link} to={"/login"}>
                  Login
                </Nav.Link>
              )}
              {user ? (
                <Nav.Link as={Link} to={"/addNewProduct"}>
                  Add Item
                </Nav.Link>
              ) : (
                ""
              )}
              {user ? (
                <Nav.Link as={Link} to={"/manageInventory"}>
                  Manage Items
                </Nav.Link>
              ) : (
                ""
              )}
              {user ? (
                <Nav.Link as={Link} to={"/myItem"}>
                  My Items
                </Nav.Link>
              ) : (
                ""
              )}
              <Nav.Link as={Link} to={"/blogs"}>
                Blogs
              </Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </div>
  );
};

export default Header;
